import type { EventRuleException } from '@tebuto/api/therapists/models/EventRuleException'
import { DateTime } from 'luxon'

type ExceptionPayload = EventRuleException['payload']

export function isCrossDayMoveExceptionPayload(payload: ExceptionPayload): boolean {
    return payload.type === 'skip' && typeof payload.spawnedRuleId === 'number'
}

export function isMoveException(exception: EventRuleException): boolean {
    return exception.payload.type === 'move' || isCrossDayMoveExceptionPayload(exception.payload)
}

export function isSkipOnlyException(exception: EventRuleException): boolean {
    return exception.payload.type === 'skip' && !isCrossDayMoveExceptionPayload(exception.payload)
}

export function resolveMovedOccurrenceStart(
    exception: EventRuleException,
    ruleStartIso: string
): DateTime<true> | null {
    const ruleStartDateTime = DateTime.fromISO(ruleStartIso) as DateTime<true>
    const exceptionDate = DateTime.fromISO(exception.date) as DateTime<true>

    if (exception.payload.type === 'move') {
        return exceptionDate
            .set({ hour: ruleStartDateTime.hour, minute: ruleStartDateTime.minute })
            .plus({ milliseconds: exception.payload.diffMilliseconds }) as DateTime<true>
    }

    if (isCrossDayMoveExceptionPayload(exception.payload)) {
        const movedToStart =
            typeof exception.payload.movedToStart === 'string' ? DateTime.fromISO(exception.payload.movedToStart) : null
        if (movedToStart?.isValid) {
            return movedToStart as DateTime<true>
        }
    }

    return null
}

export function formatExceptionOriginDate(exception: EventRuleException): string {
    return (DateTime.fromISO(exception.date) as DateTime<true>).setLocale('de').toFormat('DDD')
}
